import { useState } from 'react';
import { Row, Col, Form, Button, Alert, Accordion } from 'react-bootstrap';
import { searchUser } from '../../../services/adminService';
import UpdateUserRoles from './UpdateUserRoles';

const CreateUser = () => {
    const [formData, setFormData] = useState({
        userEmail: ''
    });

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [foundUserEmail, setFoundUserEmail] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const result = await searchUser(formData);

            if (result) {
                setSuccessMessage('User found.');
                setFormData({
                    userEmail: ''
                });
                setFoundUserEmail(result.email);
            }
        } catch (error) {
            setErrorMessage('Failed to find user with that email.');
            console.error(error);
        }
    };

    return (
            <div className="component findUser">
                <Accordion defaultActiveKey={null}> {/* Ensures it's collapsed by default */}
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <Row>
                                <Col>
                                    <h3>Search User</h3>
                                </Col>
                            </Row>
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row>
                                <Col xs={12}>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group controlId="userEmail" className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control type="text" name="userEmail" value={formData.userEmail} onChange={handleChange} required />
                                        </Form.Group>

                                        <Button variant="primary" type="submit" className="mb-3">
                                            Find User
                                        </Button>
                                    </Form>
                                    {successMessage && <Alert variant="success">{successMessage}</Alert>}
                                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                                    {foundUserEmail && (
                                        <UpdateUserRoles userEmail={foundUserEmail} />
                                    )
                                    }
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
    );
};

export default CreateUser;
